export default __webpack_public_path__ + "static/media/02.a4db66d7.jpg";